#
# Discussion specific UI bindings.
#

$(document).on 'turbo:load', ->
  # Use mustache template formatting for underscore templates
  _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

  # Frontend UI events
  # ------------------------
  #
  $('#discuss')
    #
    # Block submit if comment field is empty.
    #
    .on "click", "[data-behavior=submit-response]", (e) ->
      $commentField = $(this)
        .closest("form")
        .find("[data-input-field='response']")
      if !$.trim($commentField.val())
        e.preventDefault()
        alert('Comment cannot be blank.')

    #
    # hide comment form
    #
    .on "click", "[data-behavior=cancel-form]", (e) ->
      e.preventDefault()
      $(this).closest('[data-cancel-form]').remove()
      $('#discuss').find('.join').removeClass('hide')
      $('.oratorStart').show()

    #
    # Block submit if discussion title is empty.
    #
    .on "click", "[data-behavior=submit-discussion]", (e) ->
      $titleField = $(this)
        .closest("form")
        .find("[data-input-field='title']")
      if !$.trim($titleField.val())
        e.preventDefault()
        alert('Discussion title cannot be blank.')